<script setup>
import {router} from "@inertiajs/vue3";
import Dialog from "primevue/dialog";
import {computed, ref, watch} from "vue";

const model = defineModel();
const start = defineModel('start');

const cleanModel = computed(() => {
    if (!model.value) {
        return null;
    }

    return {
        ...model.value,
        rentalItems: JSON.stringify(model.value.rentalItems ?? []),
        formBuilder: JSON.stringify(model.value.formBuilder ?? []),
    };
});

const sent = ref(false);

watch(start, (now) => {
    if (now && !sent.value) {
        router.post('/app/forms/send', cleanModel.value);
        sent.value = true;
    }
});
</script>

<template>
    <div>
        <p class="text-lg -mt-8">{{ $t('forms.recap_will_create', { name: cleanModel?.settings?.name }) }}</p>

        <Dialog v-model:visible="start" :draggable="false" modal position="center" :style="{ width: '25rem' }">
            <template #container>
                <div class="p-6 flex flex-col gap-6 items-center">
                    <div>
                        <i class="pi pi-spin pi-spinner" style="font-size: 3rem"></i>
                    </div>
                    <p>{{ $t('forms.recap_creating_page') }}</p>
                </div>
            </template>
        </Dialog>
    </div>
</template>
